var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-5" }, [
    _c(
      "div",
      { staticClass: "pl-20 pr-20 pb-10 bg-white" },
      [
        _c(
          "el-button",
          {
            staticClass: "mb-20 mt-20",
            attrs: { type: "success" },
            on: {
              click: function ($event) {
                return _vm.save_plan.push(_vm.defaultAd)
              },
            },
          },
          [_vm._v("添加广告")]
        ),
        _vm._v(" "),
        _c(
          "el-form",
          { ref: "form", attrs: { "label-width": "auto" } },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.save_plan, border: "" },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "广告图片(2:1)", width: "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("upload", {
                            attrs: { ratio: "" },
                            model: {
                              value: scope.row.banner_url,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "banner_url", $$v)
                              },
                              expression: "scope.row.banner_url",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "跳转小程序APPID", width: "350" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mb-10",
                              attrs: { label: "微信：" },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入微信小程序APPID" },
                                model: {
                                  value: scope.row.wx_appid,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "wx_appid", $$v)
                                  },
                                  expression: "scope.row.wx_appid",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mb-0",
                              attrs: { label: "支付宝：" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入支付宝小程序APPID",
                                },
                                model: {
                                  value: scope.row.zfb_appid,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "zfb_appid", $$v)
                                  },
                                  expression: "scope.row.zfb_appid",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "页面路径" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mb-10",
                              attrs: { label: "微信：" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入微信小程序页面路径",
                                },
                                model: {
                                  value: scope.row.wx_jump_url,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "wx_jump_url", $$v)
                                  },
                                  expression: "scope.row.wx_jump_url",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mb-0",
                              attrs: { label: "支付宝：" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入支付宝小程序页面路径",
                                },
                                model: {
                                  value: scope.row.zfb_jump_url,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "zfb_jump_url", $$v)
                                  },
                                  expression: "scope.row.zfb_jump_url",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "展示设备", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: scope.row.depend_type,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "depend_type", $$v)
                                },
                                expression: "scope.row.depend_type",
                              },
                            },
                            _vm._l(_vm.deviceNameObj, function (item, key) {
                              return _c(
                                "el-checkbox",
                                { attrs: { label: item } },
                                [_vm._v(_vm._s(key))]
                              )
                            }),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "danger",
                                round: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.save_plan.splice(scope.$index, 1)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "mt-30" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                  [_vm._v("立即提交")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }